module.exports = function (app) {
    "use strict";
    require("pages/clientAndGroup/group")(app);
    app.controller('pages.groupList', ["$state", "$scope", "services", "sessionData","storage", function ($state, $scope, services, sessionData,storage) {
        if ((sessionData.entitlements.clientStatus.cancelled == true)
            && (!sessionData.cancelledClientHasAgreed)) {
            $state.go('cancelledConditions');
        }

        // Sidebar
        $scope.$parent.sidebar = {
            breadCrumb: {
                primary: {
                    // title: "Groups",
                    state: ""
                } }  };
        $scope.icisgroupcount = {};
        $scope.groups = {
            orderBy: 'groupNumber',
            reverse: true,
            status: 'Active',
            pagination: {
                itemsPerPage: 25,
                page: 1
            },
            titles: [
                {
                    name: "Group Number",
                    dataKey: "groupNumber"
                },
                {
                    name: "Group Name",
                    dataKey: "groupName"
                },
                {
                    name: "Group Status",
                    dataKey: "status"
                }
            ],
            rows:[
                // pds: this array becomes "refinedGroups" in the html
                //{
                //    groupNumber: "04706911",
                //    groupName: "Pittsburgh Public Schools",
                //    status: "Active"
                //}
                //,
                //{
                //    groupNumber: "04706911",
                //    groupName: "Group 2",
                //    status: "Cancelled"
                //},
                //{
                //    groupNumber: "04706911",
                //    groupName: "Group 3",
                //    status: "Active"
                //},
                //{
                //    groupNumber: "04706911",
                //    groupName: "Group 4",
                //    status: "Cancelled"
                //}
            ],
            customFilter : function(group){
                return (!$scope.groups.search || group.groupNumber.indexOf($scope.groups.search) >= 0 || group.groupName.toLowerCase().indexOf($scope.groups.search.toLowerCase()) >= 0) && ($scope.groups.status==='All' || group.status === $scope.groups.status);
            }
        };

        var populateStubArray = function() {
            alert('populateStubArray is not ready')
        }
        var useStub = false;
        $scope.sidebar.breadCrumb.primary.title = 'Groups for ' + sessionData.employerInfo.planAdministrator.company;
        var handleServiceSuccess = function(retObj, theCaller) {
            $scope.getGroupsSvcIsRunning = false;
            if (retObj && retObj.data && retObj.data.payload && retObj.data.payload) {
                $scope.serviceReturnedItems = true;
                var theGroups = retObj.data.payload;
                var icisGroup = getICISGroupObject(theGroups);
                $scope.icisgroupcount["ccount"] = icisGroup['icisgroupcount'].ccount;
                $scope.icisgroupcount["acount"] = icisGroup['icisgroupcount'].acount;
                $scope.icisgroupcount["tcount"] = icisGroup['icisgroupcount'].tcount;
                theGroups = removeCountInfoFromGroups(theGroups);
                if (theGroups.length > 0) {
                    $scope.groups.rows = theGroups;
                } else {
                    alert("The service returned no groups.")
                }
            } else {
                alert("The service returned something unexpected.");
            }
        }
        var removeCountInfoFromGroups = function(theGroups){
            if(theGroups.length != 0){
                return theGroups.filter(function(g){
                    if(g.icisgroupcount == undefined){return g;}
                })
            }
        }
        var getICISGroupObject = function(groupsObj){
            if(groupsObj.length != 0){
                var icisGru = groupsObj.filter(function(g,i){
                    if(g.icisgroupcount != undefined){return g;}
                }); 
                return icisGru[0];               
            }
        }
        var handleServiceFailure = function(err, theCaller) {
            $scope.getGroupsSvcIsRunning = false;
            if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
                console.error(err.data.baseMessage.returnCodeDescription)
                console.error('No items found for service = ' + theCaller);
            } else {
                alert("We are unable to process the request right now, Please try again later.");
            }
        }

        var getItemsFromService = function() {
            $scope.getGroupsSvcIsRunning = true;
            if (useStub) {
                populateStubArray();
                return;
            }          
            if(storage.get("multiBrand")==="true")
            {
                var loginId=sessionData.basicInfo.loginId;
                var vendorName=storage.get("currentBrand");
                services.eprsvc.clientInformation().getBrandGroups(loginId,vendorName).then(function (resObj) {
                    handleServiceSuccess(resObj);
                }, function (err) {
                    handleServiceFailure(err);
                });
            
            }else
            {
                services.eprsvc.clientInformation().getGroups().then(function (retObj) {
                    handleServiceSuccess(retObj);
                }, function (err) {
                    handleServiceFailure(err);
                });
            }           
        }
        getItemsFromService();

    }]);

    return [
        {
            state: "groupList",
            url: "/group-list",
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html']
                },
                "content@groupList": {
                    templateUrl: "group-list.employerTemplate.html/pages/clientAndGroup/group-list",
                    controller: "pages.groupList"
                } } }
        , {
            state: "groupInfo",
            url: "/group-info",
            // pds: url: "/group-info?groupNumber&groupName&status",
            postPassword: true,
            abstract: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page-side-bar.html'],
                    controller: "pages.groupInfo"
                } }
        },
        {
            state: "groupInfo.generalInfo",
            url: "/general-info?groupNumber?groupName?status",
            postPassword: true,
            views: {
                "content@groupInfo": {
                    templateUrl: "group-info/general-info.employerTemplate.html/pages/clientAndGroup/general-info"
                }
            }
        },
        {
            state: "groupInfo.contacts",
            url: "/contacts",
            postPassword: true,
            views: {
                "content@groupInfo": {
                    templateUrl: "group-info/contacts.employerTemplate.html/pages/clientAndGroup/contacts"
                }
            }
        }
    ];
};
